import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function removeCertificateReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return Map({
        loading: true,
        data: null,
        error: null,
      });
    case actionTypes.REQUEST_SUCCESS:
      return Map({
        loading: false,
        data: action.payload,
        error: null,
      });
    case actionTypes.REQUEST_FAILURE:
      return Map({
        loading: false,
        data: null,
        error: action.payload,
      });
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
}
